import { camelCase } from 'change-case';
import { FieldValues, SetValueConfig, UseFormSetValue } from 'react-hook-form';

import { upperCaseFirstCharacter } from '~/core/shared/utils/general';

export const setMetaPropertiesOnForm = (
  name: string,
  meta: Record<string, unknown> | undefined,
  setValue: UseFormSetValue<FieldValues>,
  options?: SetValueConfig,
): void => {
  if (!meta) return;

  const dottedName = name.replaceAll('~', '.');

  Object.entries(meta).forEach(([key, value]) => {
    const formattedKey = upperCaseFirstCharacter(camelCase(key));
    setValue(`${dottedName}Meta${formattedKey}`, value, options);
  });
};
